// clean localstorage
// clean indexeddb

const glob = {
  c: 2019,
  d: "jnpn"
};

class AppState {
  prologue() {
    console.log("-----------------------------");
    console.log("--- lebobo pos applicatoin --");
    console.log("--- (c) jnpn <2019-...> -----");
  }

  valid() {
    let database_ok = true;
    let database_empty = true;
    let meta_ok = true;
    return database_ok && meta_ok && database_empty;
  }

  install(Vue, options) {
    console.log("appstate:install", Vue, options);
    Vue.$jnpn = "yolo";
    Vue.prototype.$app = () => {
      return glob;
    };
    Vue.mixin({
      beforeCreate() {
        /**/
      },
      created() {
        /**/
      },
      destroyed() {
        /**/
      }
    });
    console.log("appstate:install done");
    this.prologue();
  }
}

export default AppState;
